import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND;

export const getProvinces = async () => {
	try {
		const response = await axios.get(`${API_BASE_URL}/provinces`);
		return response.data.provincias;
	} catch (error) {
		console.error('Error fetching provinces:', error);
		throw new Error('Failed to fetch provinces');
	}
};

export const getMunicipalities = async (provinceId: string) => {
	try {
		const response = await axios.get(
			`${API_BASE_URL}/municipalities?provinceId=${provinceId}`,
		);

		return response.data.municipios;
	} catch (error) {
		console.error(
			`Error fetching municipalities for province ${provinceId}:`,
			error,
		);
		throw new Error('Failed to fetch municipalities');
	}
};
